import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

// Ranks the control-measure library against the hazard being assessed. Hosted by the
// same Next.js backend as the AI writing routes, not a Blueprint microservice, so the
// Blueprint environment to verify the bearer token against is sent in the body. The
// token itself is attached by the app-wide AuthInterceptor.
//
// Every suggestion is a library row a consultant wrote. Nothing here is generated.

export interface SuggestedControlMeasure {
  id: string;
  value: string;
  measureType: string;
  measureTypeId: number;
  language: string;
  /** Cross-encoder relevance, 0 to 1. Not comparable between different hazards. */
  score: number;
}

export interface SuggestionContext {
  hazard: string;
  machineName?: string;
  stepName?: string;
  measureTypeId?: number;
  /** Blueprint language code. Rows in other languages are excluded; rows too short
   *  to place in any language are always kept. */
  language?: string;
}

export interface SuggestionResult {
  suggestions: SuggestedControlMeasure[];
  /** Rows the filter left to rank over. Shown so the count explains the five. */
  total: number;
}

@Injectable({ providedIn: 'root' })
export class ControlMeasureSuggestionsService {
  constructor(private http: HttpClient) {}

  async forHazard(context: SuggestionContext): Promise<SuggestionResult> {
    const res: any = await this.http
      .post(`${environment.aiWritingBaseUrl}/api/control-measures/recommend`, {
        ...context,
        apiUrl: environment.tokenEndpoint,
      })
      .toPromise();
    return { suggestions: res?.suggestions || [], total: res?.total || 0 };
  }
}
